export const LOGIN_SCREEN_DATA = {
  title: "Let's log in to your account.",
  first_time_login_title: "Let's log in to your account for the first time.",
  help_text: 'Let me know if you need any help!\nSay something like:',
  help_example: `"Hey Pixi, I don't know my password"`,
};

export const NON_AUTH_CHAT_DATA = {
  application_id: 19,
};

export const INTENT_LABELS = {
  LOGIN_SCREEN_SHOWN: 'Onboarding_flow_login_start',
  USER_IS_IDLE: 'Onboarding_ambient_help',
};
